<template>
    <!-- 1.page-container-start -->
    <div class="page flexStyle4">
        <div class="left flexStyle2">
            <div class="item">共 {{totalData}} 条，每页 {{pagesData}} 条 共 {{totalPages}} 页</div>
            <div class="item">当前页码: {{currentPages}}</div>
            <div class="item">
                <div class="hands text c-animation3" @click="upPage">上一页</div>
            </div>
            <div class="item">
                <div class="hands text c-animation3" @click="downPage">下一页</div>
            </div>
        </div>
        <div class="right flexStyle1">
            <input min="1" max="1000" v-model="targetPage" type="number" placeholder="页码" class="left c-animation">
            <div class="hands right c-animation3" @click="turn">转跳</div>
        </div>
    </div>
    <!-- 1.page-container-end -->
</template>

<script>
export default {
    data(){                                         // 1.data
        return {
            targetPage: '',                         // 1.1.目标页面
        }
    },

    methods: {                                      // 2.methods              
        upPage(){                                   // 2.1.上一页
            if (this.currentPages>=2){
                this.$emit('uppage');
            }else{
                this.$notify({
                    title: '提示',
                    message: '已经是第一页'
                });
            }
        },

        downPage(){                                 // 2.2.下一页
            if (this.totalPages > this.currentPages){
                this.$emit('downpage');
            }else{
                this.$notify({
                    title: '提示',
                    message: '已经是最后一页'
                });
            }
        },

        turn(){                                     // 2.3.转跳
            if (!this.targetPage.trim() || this.targetPage < 1 || this.targetPage > this.totalPages || this.targetPage == this.currentPages){
                this.$notify({
                    title: '提示',
                    message: '请输入正确页码'
                });
            }else{
                this.$emit('turn', parseInt(this.targetPage));
            }
        }
    },

    props: {                                        // 3.props
        totalPages: {                               // 3.1.总页码
            type: Number,
            default: 1
        },

        currentPages: {                            // 3.2.当前页码
            type: Number,
            default: 1
        },

        totalData:  {                              // 3.3.总条数
            type: Number,
            default: 1
        },

        pagesData:  {                              // 3.4.每页条数
            type: Number,
            default: 10
        }
    },
}
</script>

<style lang="scss" scoped>
@import './pages.scss';
</style>
